angular.module('gc.vote-popin', ['gc.user'])

.controller('VotePopinController', [
'$rootScope',
'$scope',
'$element',
'Utils',
'CommentService',
'GcUser',
function ($rootScope, $scope, $element, Utils, CommentService, GcUser) {
  'use strict';

  $scope.Utils = Utils;
  $scope.CommentService = CommentService;

  $scope.isOwner = function() {
    return GcUser.getUser() && $scope.comment.author && $scope.comment.author._id === GcUser.getUser()._id;
  };

  $scope.canModerate = function() {
    return $rootScope.gcUser && $rootScope.gcUser.can_moderate;
  };

  $scope.showSignupPopup = function() {
    $rootScope.$broadcast('show:popup', { page: 'signup', target: $element.children().first()[0] });
  };


  // Triggered when new vote incoming (triggered by rangeSlider)
  $scope.slided = function (value) {
    if (!$scope.preventSliderClick) {
      $scope.sendVote(value);
    }
  };

  $scope.close = function () {
    $scope.show = false;
    $scope.popinStyle = null;
    $rootScope.votePopin = {};

    // if vote is required but user closes vote popin
    // we  send "without opinion" vote
    if ($scope.required && !$scope.comment.rating.has_voted) $scope.sendVote(0);

    $rootScope.$broadcast('vote:cancel');
  };

  $scope.updateVoteBoost = function(boost) {
    $scope.voteBoost = boost;
    if ($scope.vote) {
      $scope.sendVote($scope.vote, true);
    }
  };

  // Sends the vote to the API
  $scope.sendVote = function (value, keepOpen) {
    $scope.vote = value;

    if (CommentService.website.custom_client === 'orange') {
      $rootScope.spupLog('[spup] sendVote() init spup ');
      var isRegistered = GcUser.initSpup(function() {
        $rootScope.spupLog('[spup] sendVote() init spup ... done');
        $scope.sendVote(value, keepOpen);
      });
      if (!isRegistered) return;
    }

    if (!GcUser.isLocallyLogged()) {
      // once user is logged-in, send vote
      var unbind = $rootScope.$on('logged_in', function () {
        unbind();
        $scope.sendVote(value);
      });
      $rootScope.$broadcast('show:popup', { page: 'signup', target: $element.children().first()[0] });
      return;
    }

    // keep a trace of the comment
    // because when closing popin we send a "without opinion" vote
    // and thus $scope.comment is not available anymore after that
    var comment = $scope.comment;

    CommentService.voteOnComment($scope.comment, value, $scope.voteBoost).then(
      function () {
        comment.rating.vote_rate = value;
        comment.rating.has_voted = true;

        mixpanel.track('comment:vote', { vote: value })
        $rootScope.$broadcast('comment:voted');

        if (!keepOpen) $scope.close();
      },
      function (resp) {
        if (resp.data && resp.data.err) {
          if (resp.data.err === 'profile required') {
            $rootScope.$broadcast('profile-popin:open', GcUser.getUser()._id, { fromMenu: true });
          }
        }
      }
    );
  };

  $(document).on('keydown.vote-popin', function(event) {
    if (!$scope.show) return ;

    if (event.keyCode === 38) { // UP
      event.preventDefault();
      $scope.vote = Math.min(3, $scope.vote + 1);
      $scope.$apply();
    }
    else if (event.keyCode === 40) { // DOWN
      event.preventDefault();
      $scope.vote = Math.max(-3, $scope.vote - 1);
      $scope.$apply();
    }
    else if (event.keyCode === 13) { // ENTER
      $scope.sendVote($scope.vote);
    }
  });


}])
.directive('votePopin', [
  '$rootScope', '$document', '$timeout', 'Utils', 'GcUser',
  function ($rootScope, $document, $timeout, Utils, GcUser)
{
  'use strict';

  return {
    scope: {
      comment: '=',
      required: '=',
    },
    restrict: 'E',
    controller: 'VotePopinController',
    templateUrl: 'votePopin.html',
    link: function ($scope, $el, attrs, controller) {

      $scope.$watch('comment', function() {
        if ($scope.comment) {
          openPopin();
        } else {
          $scope.show = false;
          // close vote popin
        }
      });

      function openPopin() {
        // preven slider click on opening (can happen on iOS)
        $scope.preventSliderClick = true;
        setTimeout(function () {
          $scope.preventSliderClick = false;
        }, 200);

        $scope.show = true;

        $timeout(function() {
          var $comment = $('#comment-' + $scope.comment._id);
          var $popin = $el.find('.gc-vote');
          var scroll = Utils.getScrollPosition();
          var bodyBox = document.querySelector('.gc-body').getBoundingClientRect();
          var popinBox = $popin[0].getBoundingClientRect();
          var rtl = $rootScope.rtl;

          // if replying to a comment and user has not voted yet
          // we show vote popin next to submit button
          if ($scope.required) {
            var $target = $comment.find('[data-vote-btn]');
            var targetBox = $target[0].getBoundingClientRect();
            $scope.popinStyle = {
              left: (Math.round(
                (rtl ? targetBox.right : targetBox.left)
                + (rtl ? 0 : -popinBox.width)
                - bodyBox.left
                + scroll.left)
                + (rtl ? -120 : 120) +
              'px'),
              top: Math.round(
                targetBox.bottom +
                scroll.top +
                15
              ) + 'px',
            };
          }

          // else we show vote popin next to vote icon
          else {
            var $target = $comment.find('[data-vote-btn]');
            var targetBox = $target[0].getBoundingClientRect();
            $scope.popinStyle = {
              left: Math.round((rtl ? targetBox.right : targetBox.left) - bodyBox.left + scroll.left + (rtl ? 0 : -popinBox.width)) + (rtl ? 10 : -10) + 'px',
              top: Math.round(targetBox.top + (targetBox.height / 2) + scroll.top - (popinBox.height / 2)) + 'px',
            };
          }
        });

        var existingVote;
        if (GcUser.getUser()) {
          existingVote = $scope.comment.voters.find(v => v.user === GcUser.getUser()._id);
        }
        $scope.voteBoost = existingVote ? (existingVote.boost || 0) : 0;
        $scope.vote = $scope.comment.rating ? ($scope.comment.rating.vote_rate || 0) : 0;

        // only for mobiles
        var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (screenWidth < 400) {
          setTimeout(function () {
            var $vote = document.querySelector('.gc-vote');
            var voteWidth = $vote.offsetWidth;
            var pos = $vote.getBoundingClientRect();
            var leftMargin = parseInt(getComputedStyle(document.querySelector('.gc-vote'))['margin-left'], 10);

            // center vote popin horizontally
            $vote.style.marginLeft =  (screenWidth / 2 - voteWidth / 2 - pos.x + leftMargin) + 'px';
          }, 0);
        }
      }

    }
  };
}]);
